import { Parameters } from '@provider-portal/common/api/gen/DeliveryProviderPortalAuthApi';

import { NetworkRequestState } from '@bolteu/redux-session';

import { GlobalAppState } from 'rdx/state';

export const selectTargetingParametersIsRequestFinished = (state: GlobalAppState) => {
  return (
    state.targetingParameters.fetchingState === NetworkRequestState.success ||
    state.targetingParameters.fetchingState === NetworkRequestState.failure
  );
};

export const selectTargetingParameters = (state: GlobalAppState): Parameters => {
  return state.targetingParameters.parameters;
};
